var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notfound"},[_c('h1',[_vm._v("404: Not Found")]),_c('a',{attrs:{"href":"/","size":"sm"}},[_c('b-icon',{attrs:{"icon":"arrow-clockwise"}}),_vm._v(" Fresh Quote")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }